import {
  Tabs,
  TextField,
  Select,
  Page,
  BlockStack,
  Button,
  LegacyCard,
  Toast,
  SkeletonBodyText,
  Frame
} from "@shopify/polaris";
import { useState, useCallback, useEffect } from "react";
import Axios from "./common/Axios";

export default function Settings() {
  const data = {
    published: "Published",
    tags: "",
    defaultVendor: "",
    product_type: "",
    inventory_policy: "no_track",
    // defaultQuantity: 0,
    // defaultCurrency: "USD",
    desc_cond: "Disable",
    desc_itemspecs: "Disable",
    Max_Inventory: 0,
    AutoImportProducts: "Disable",
    InventorySyncShopifyOrders: "Disable",
    // autoCurrencyConversion: "Disable",
    enablePriceMarkup: "disable",
    markupType: "FIXED",
    markupValue: 0,
    markupRoundOff: "no_round",
    inventorySync: "disable",
    // outOfStockAction: "outofstock",
    priceSync: "disable",
  }

  const [formState, setFormState] = useState({
    published: data.published,
    tags: data.tags,
    defaultVendor: data.defaultVendor,
    product_type: data.product_type,
    inventory_policy: data.inventory_policy,
    // defaultQuantity: data.defaultQuantity,
    // defaultCurrency: data.defaultCurrency,
    desc_cond: data.desc_cond,
    desc_itemspecs: data.desc_itemspecs,
    Max_Inventory: data.Max_Inventory,
    AutoImportProducts: data.AutoImportProducts,
    InventorySyncShopifyOrders: data.InventorySyncShopifyOrders,
    // autoCurrencyConversion: data.autoCurrencyConversion,
    enablePriceMarkup: data.enablePriceMarkup,
    markupType: data.markupType,
    markupValue: data.markupValue,
    markupRoundOff: data.markupRoundOff,
    inventorySync: data.inventorySync,
    // outOfStockAction: data.outOfStockAction,
    priceSync: data.priceSync,
  });
  const [selected, setSelected] = useState(0);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [activeToast, setActiveToast] = useState(false);
  const [toastMessage, setToastMessage] = useState(false);

  const toggleActive = useCallback(() => setActiveToast((activeToast) => !activeToast), []);

  const toastMarkup = activeToast ? (
    <Toast content={!toastMessage ? "Settings saved successfully." : "Something went wrong!"} onDismiss={toggleActive} />
  ) : null;



  useEffect(() => {
    handleGetSettings();
  }, []);

  const handleGetSettings = async () => {
    setLoadingData(true);
    const stored = localStorage.getItem("storeData");
    const parsed = JSON.parse(stored);
    // const token = localStorage.getItem("token");
    if (parsed.token) {
      try {
        const response = await Axios.get((`${process.env.REACT_APP_API_URL}/settings`))
        console.log("settings -> ", response.data);
        const Data = response.data;
        if (Data) {
          setFormState({
            published:
              (!Data.published ? "Hidden" : "Published") ??
              "Published",
            tags: Data.tags ?? "",
            defaultVendor: Data.vendor ?? "",
            product_type: Data.product_type ?? "",
            inventory_policy:
              (Data.inventory_policy == "NO" ? "no_track" : "track") ??
              "no_track",
            desc_cond: !Data.desc_cond ? "Disable" : "Enable",
            desc_itemspecs: !Data.desc_itemspecs ? "Disable" : "Enable",
            Max_Inventory: Data.Max_Inventory ? Data.Max_Inventory : 0,
            enablePriceMarkup:
              (!Data.markupenabled ? "disable" : "enable") ??
              "disable",
            markupType: Data.markuptype == "FIXED" ? "FIXED" : "PERCEN",
            markupValue: Data.markupval ?? 0,
            markupRoundOff:
              (!Data.markupround ? "no_round" : "round_nearest") ??
              "no_round",
            inventorySync:
              (!Data.inventory_sync ? "disable" : "enable") ??
              "disable",
            // outOfStockAction: Data.outofstock_action ?? "outofstock",
            priceSync:
              (!Data.price_sync ? "disable" : "enable") ?? "disable",
            AutoImportProducts: !Data.autoimport ? "Disable" : "Enable",
            InventorySyncShopifyOrders: !Data.shopifyorders ? "Disable" : "Enable",
          });
        }
        setLoadingData(false);
      } catch (error) {
        setLoadingData(false);
        console.log("Something went wrong!");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // shopify.loading(true);
    setButtonLoading(true);
    try {
      console.log("Submitted Form Data:", formState);

      // const encodedData = encodeURIComponent(JSON.stringify(formState));

      const response = await Axios.put(
        `${process.env.REACT_APP_API_URL}/settings`,
        formState
      );
    
      const data = response.data.status;
      if(data == "success"){
        setToastMessage(false)
        toggleActive()
      }else{
        setToastMessage(true)
        toggleActive()
      }
       
      window.scrollTo({ top: 0, behavior: "smooth" });

    } catch (error) {
      console.error("Submission failed:", error);
      // shopify.toast.show("Something went wrong", { duration: 3000 });
    } finally {
      // Stop loading and button state after a slight delay
      setTimeout(() => {
        // shopify.loading(false);
        setButtonLoading(false);
      }, 1000);
    }
  };

  const handleChange = (field) => (value) => {
    setFormState((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const inventoryOptions = [
    // { label: "Select Inventory", value: "" },
    { label: "Shopify Tracks This Product's Inventory", value: "track" },
    { label: "Do Not Track Inventory", value: "no_track" },
  ];

  const IncludeConditionDataOption = [
    { label: "Disable", value: "Disable" },
    { label: "Enable", value: "Enable" },
  ];

  const IncludeItemSpecificDataOption = [
    { label: "Disable", value: "Disable" },
    { label: "Enable", value: "Enable" },
  ];

  const publishOptions = [
    { label: "Published", value: "Published" },
    { label: "Hidden", value: "Hidden" },
  ];

  const handleTabChange = useCallback(
    (selectedTabIndex) => setSelected(selectedTabIndex),
    [],
  );

  const tabs = [
    {
      id: "general-settings",
      content: "General Settings",
      panelID: "general-settings-content",
    },
    {
      id: "pricing-rules",
      content:
        "Pricing Rules",

      panelID: "pricing-rules-content",
    },
    {
      id: "auto-sync-rules",
      content: "Auto Sync Rules",
      panelID: "auto-sync-content",
    },
  ];

  const renderGeneralSettingsForm = () => (
    <div
      style={{
        margin: "1%",
        padding: "1rem",
        borderRadius: "8px",
        backgroundColor: "#fbfbfb",
      }}
    >
      {loadingData ? (
        <SkeletonBodyText lines={25} />
      ) : (
        <BlockStack gap="400">
          <Select
            label="Products should be published?"
            options={publishOptions}
            name="published"
            value={formState.published}
            onChange={handleChange("published")}
          />
          <TextField
            label="Default Tags"
            name="tags"
            placeholder="T-shirt, Mens"
            value={formState.tags}
            onChange={handleChange("tags")}
          />
          <TextField
            label="Default Vendor"
            name="defaultVendor"
            placeholder="Leave blank to fill from amazon"
            value={formState.defaultVendor}
            onChange={handleChange("defaultVendor")}
          />
          <TextField
            label="Default Product Type"
            name="product_type"
            placeholder="Leave blank to fill from amazon"
            value={formState.product_type}
            onChange={handleChange("product_type")}
          />
          <Select
            label="Inventory Policy"
            options={inventoryOptions}
            name="inventory_policy"
            value={formState.inventory_policy}
            onChange={handleChange("inventory_policy")}
          />
          <Select
            label="Include Condition data in description"
            options={IncludeConditionDataOption}
            name="desc_cond"
            value={formState.desc_cond}
            onChange={handleChange("desc_cond")}
          />
          <Select
            label="Include Item Specific data in description"
            options={IncludeItemSpecificDataOption}
            name="desc_itemspecs"
            value={formState.desc_itemspecs}
            onChange={handleChange("desc_itemspecs")}
          />
          <TextField
            label="Max Inventory"
            name="Max_Inventory"
            placeholder="Enter max quantity of product to import on ebay (Shopify to eBay)"
            value={formState.Max_Inventory}
            onChange={handleChange("Max_Inventory")}
          />

        </BlockStack>
      )}
    </div>
  );
  const renderPricingRulesForm = () => (
    <div
      style={{
        margin: "1%",
        padding: "1rem",
        borderRadius: "8px",
        backgroundColor: "#fbfbfb",
      }}
    >
      {loadingData ? (
        <SkeletonBodyText lines={15} />
      ) : (
        <BlockStack gap="400">
          <Select
            label="Price Markup"
            options={[
              { label: "Disable", value: "disable" },
              { label: "Enable", value: "enable" },
            ]}
            name="enablePriceMarkup"
            value={formState.enablePriceMarkup}
            onChange={handleChange("enablePriceMarkup")}
          />

          <Select
            label="Markup Type"
            options={[
              { label: "Fixed Amount", value: "FIXED" },
              { label: "Percentage", value: "PERCEN" },
            ]}
            name="markupType"
            value={formState.markupType}
            onChange={handleChange("markupType")}
            disabled={formState.enablePriceMarkup == "disable"}
          />

          <TextField
            label="Markup Value"
            name="markupValue"
            placeholder="Enter markup value"
            value={String(formState.markupValue)}
            onChange={handleChange("markupValue")}
            disabled={formState.enablePriceMarkup == "disable"}
          />

          <Select
            label="Markup Round Off"
            options={[
              { label: "Do not round off price", value: "no_round" },
              {
                label: "Round off to nearest whole number",
                value: "round_nearest",
              },
            ]}
            name="markupRoundOff"
            value={formState.markupRoundOff}
            onChange={handleChange("markupRoundOff")}
            disabled={formState.enablePriceMarkup == "disable"}
          />

          {/* <Button submit variant="primary">
    Submit
  </Button> */}
        </BlockStack>
      )}
    </div>
  );
  const renderAutosyncForm = () => (
    <div
      style={{
        margin: "1%",
        padding: "1rem",
        borderRadius: "8px",
        backgroundColor: "#fbfbfb",
      }}
    >
      {loadingData ? (
        <SkeletonBodyText lines={15} />
      ) : (
        <BlockStack gap="400">
          {/* <p style={{ color: "green", fontWeight: "bold" }}>
            These Settings Work In Auto Sync Which Runs Every 24 Hours.
          </p> */}

          <Select
            label="Inventory Synchronization"
            options={[
              { label: "Disable", value: "disable" },
              { label: "Enable", value: "enable" },
            ]}
            name="inventorySync"
            value={formState.inventorySync}
            onChange={handleChange("inventorySync")}
          />
          <Select
            label="Price Synchronization"
            options={[
              { label: "Disable", value: "disable" },
              { label: "Enable", value: "enable" },
            ]}
            name="priceSync"
            value={formState.priceSync}
            onChange={handleChange("priceSync")}
          />


          <Select
            label="Auto Import Products"
            options={[
              { label: "Disable", value: "Disable" },
              { label: "Enable", value: "Enable" },
            ]}
            name="AutoImportProducts"
            value={formState.AutoImportProducts}
            onChange={handleChange("AutoImportProducts")}
            disabled={true}
            error={
              formState.AutoImportProducts === "Disable"
                ? "Total active items in your eBay account should be under your monthly plan limit. Please send an email to epihelp@infoshore.biz to update this setting."
                : undefined
            }
          />



          <Select
            label="Inventory sync on Shopify orders"
            options={[
              { label: "Disable", value: "Disable" },
              { label: "Enable", value: "Enable" },
            ]}
            name="InventorysynconShopifyorders"
            value={formState.InventorySyncShopifyOrders}
            onChange={handleChange("InventorysynconShopifyorders")}
            disabled={true}
            error={
              formState.InventorySyncShopifyOrders === "Disable"
                ? "Total active items in your eBay account should be under your monthly plan limit. Please send an email to epihelp@infoshore.biz to update this setting."
                : undefined
            }
          />

          {/* <Select
            label="Out-Of-Stock Action"
            options={[
              {
                label: "Mark as Sold Out (Quantity = 0) on Shopify",
                value: "outofstock",
              },
              { label: "Unpublish Product from Shopify", value: "unpublish" },
              { label: "Delete Product from Shopify", value: "delete" },
            ]}
            name="outOfStockAction"
            value={formState.outOfStockAction}
            onChange={handleChange("outOfStockAction")}
          /> */}



          {/* <Button submit variant="primary">
          Submit
        </Button> */}
        </BlockStack>
      )}
    </div>
  );

  return (
    <Page>

      <div style={{ marginBottom: "2%" }}>
        <BlockStack gap="400">
          <LegacyCard>
            <Tabs
              tabs={tabs}
              selected={selected}
              onSelect={handleTabChange}
              fitted
            />
            <form onSubmit={handleSubmit}>
              {selected === 0 && renderGeneralSettingsForm()}
              {selected === 1 && renderPricingRulesForm()}
              {selected === 2 && renderAutosyncForm()}
              <Button
                loading={buttonLoading}
                variant="primary"
                fullWidth
                submit
              >
                Submit
              </Button>
            </form>
          </LegacyCard>
        </BlockStack>
      </div>
      
        {toastMarkup}

    </Page>
  );
}
